import * as React from 'react';

// AI-Generated Documentation - Please Read with Caution

type Props = {
  /** Custom styles to apply to the card */
  style?: $TSFixMe;
  /** When true, removes the minHeight constraint */
  flexibleHeight?: boolean;
  /**
   * When true, sets a minimum height of 90vh
   * @default true
   */
  minHeight?: boolean;
  /** Additional CSS class names to apply */
  className?: string;
};

/** A container component that renders content in a card-like UI element. */
class Card extends React.LegacyComponentWithChildren<Props> {
  render() {
    const style = this.props.minHeight ? Object.assign({ minHeight: '90vh' }, this.props.style) : this.props.style;
    if (this.props.flexibleHeight) {
      delete style.minHeight;
    }
    return (
      <div className={`card well no-padding white no-margin ${this.props.className || ''}`} style={style}>
        {this.props.children}
      </div>
    );
  }
}

// @ts-expect-error ts-migrate(2339) FIXME: Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
Card.defaultProps = {
  minHeight: true,
};

export default Card;
